// ЄДИНЕ ДЖЕРЕЛО ТЕКСТУ РОЗДІЛУ «УМОВИ КОРИСТУВАННЯ».
//
// Для гостя tpay і qr-menu — один продукт, тож умови в них мають збігатися слово
// в слово. Цей файл існує двома ідентичними копіями:
//     tpay/src/utils/termsContent.js
//     qr-menu/src/utils/termsContent.js
// Будь-яка правка тексту вноситься одночасно в обидві.
//
// Каркас узятий з Угоди користувача skymarket, але зміст перероблено під заклад
// харчування. У skymarket текст написаний для роздрібного магазину — Нова Пошта,
// товарний вигляд, пломби, повернення протягом 14 днів. Для страви за столом це
// не працює: їжа належної якості поверненню не підлягає взагалі (Постанова КМУ
// № 172), а обслуговування відбувається на місці.
//
// Пріоритет має бекенд: якщо getStart віддає terms[key], цей текст додається до
// відповідного розділу. Так юридичні формулювання можна міняти без релізу фронтів.
//
// !!! TODO(ticket-7877): позиції, позначені нижче коментарем LEGAL, потребують
// підтвердження юриста перед публікацією на реальних закладах.

// Дату останньої редакції на сторінці не показуємо: константа, яку треба
// синхронно правити у двох репозиторіях, рано чи пізно відстане від тексту,
// а застаріла дата гірша за її відсутність. Положення розділу «Строк дії»
// про редакцію на момент оплати від цього не залежить — воно зобов'язує
// Заклад незалежно від того, чи бачить гість дату.

const p = (text) => ({ type: "p", text });
// Пункт списку — або рядок, або { parts: [...] } для тексту з посиланням
// усередині речення. Частина з href рендериться як <a>, решта — як текст;
// v-html свідомо не використовуємо.
const ul = (items) => ({ type: "ul", items });

// Текст має бути універсальним для всіх закладів. Усе, що відрізняється від
// закладу до закладу, приходить аргументами або з getStart().terms — у самому
// тексті не має бути тверджень, які справджуються лише для частини закладів.
//   sellerName        — реквізити конкретного продавця (підставляються);
//   paymentSystemName — назва платіжки, у різних закладів різна;
//   isLiqPay          — ліміт 29 999,99 грн є правилом саме LiqPay, не загальним;
//   hasOnlinePayment  — заклад може працювати з withoutPay, тоді тверджень про
//                       онлайн-оплату в оферті бути не повинно.
export const buildTermsSections = ({
  sellerName = "",
  paymentSystemName = "",
  paymentTermsUrl = "",
  isLiqPay = false,
  hasOnlinePayment = true,
  terms = null,
} = {}) => {
  const seller = sellerName ? `«${sellerName}»` : "закладу";
  const viaService = paymentSystemName
    ? `через платіжний сервіс ${paymentSystemName}`
    : "через платіжний сервіс";

  const sections = [
    {
      key: "general",
      title: "Загальні положення",
      blocks: [
        p(
          `Ця Угода користувача (далі — Угода) є публічною офертою ${seller} (далі — Заклад) щодо надання послуг громадського харчування та продажу страв і напоїв необмеженому колу осіб (далі — Гість).`
        ),
        p(
          "Оплата рахунку або оформлення замовлення означає повну та беззастережну згоду Гостя з умовами цієї Угоди (акцепт оферти) відповідно до статей 633, 641 та 642 Цивільного кодексу України. З цього моменту Угода вважається укладеною і має силу договору."
        ),
        p(
          "Якщо ви не погоджуєтесь з умовами цієї Угоди — не оплачуйте рахунок і не оформлюйте замовлення. Ви можете розрахуватися в Закладі іншим доступним способом."
        ),
      ],
    },
    {
      key: "subject",
      title: "Предмет Угоди",
      blocks: [
        p(
          "Заклад зобов'язується надати Гостю послуги громадського харчування та передати замовлені страви й напої, а Гість — прийняти та оплатити їх на умовах цієї Угоди."
        ),
        p(
          "Перелік страв, їх опис та актуальні ціни розміщені в меню Закладу. Асортимент і наявність позицій можуть змінюватися без попереднього повідомлення."
        ),
      ],
    },
    {
      key: "order",
      title: "Замовлення та рахунок",
      blocks: [
        p(
          "Замовлення формується в Закладі — офіціантом або самостійно через електронне меню за QR-кодом столу."
        ),
        p(
          "Рахунок за замовленням відображається на сторінці, доступній за QR-кодом столу. Гість може сплатити рахунок повністю або розділити його з іншими гостями за столом, якщо така можливість доступна."
        ),
        ul([
          "Гість відповідає за те, що сплачує саме свій рахунок і за своїм столом.",
          "Заклад має право відмовити в прийнятті замовлення, якщо позиції немає в наявності або замовлення неможливо виконати.",
        ]),
      ],
    },
    {
      key: "price",
      title: "Ціна",
      blocks: [
        ul([
          "Ціни вказані у гривні та включають податки, передбачені законодавством України.",
          // Пряма вимога договору LiqPay з мерчантом: перекладати комісію
          // за еквайринг на власника картки заборонено, і банк це перевіряє.
          "Ціна однакова незалежно від способу оплати. Комісія платіжного сервісу до вартості замовлення не додається.",
          "Ціна вже сформованого та підтвердженого рахунку зміні не підлягає.",
          "Зображення страв у меню є ілюстративними — зовнішній вигляд і оформлення можуть відрізнятися.",
        ]),
      ],
    },
    {
      key: "payment",
      title: "Оплата",
      blocks: hasOnlinePayment
        ? [
            p(
              `Оплата рахунку здійснюється онлайн банківською карткою ${viaService}. Інші способи розрахунку визначає Заклад.`
            ),
            ul(
              [
                "Реквізити картки вводяться на захищеній сторінці платіжного сервісу. Заклад не отримує, не обробляє і не зберігає дані вашої картки.",
                "Приймаються платіжні картки Visa, Mastercard та інших систем, які підтримує платіжний сервіс.",
                // 29 999,99 грн — правило саме LiqPay (обмеження суми транзакції
                // з одного платіжного засобу за добу). Для інших платіжок ліміт
                // інший, тому загальним твердженням його робити не можна.
                isLiqPay
                  ? "Максимальна сума операції — 29 999,99 грн з однієї картки за добу. Це обмеження платіжного сервісу."
                  : "Обмеження на максимальну суму операції встановлює платіжний сервіс.",
                paymentTermsUrl
                  ? {
                      parts: [
                        { text: "Здійснюючи оплату, Гість також приєднується до " },
                        {
                          text: "публічного договору платіжного сервісу",
                          href: paymentTermsUrl,
                        },
                        { text: "." },
                      ],
                    }
                  : "Здійснюючи оплату, Гість також приєднується до публічного договору платіжного сервісу.",
              ].filter(Boolean)
            ),
          ]
        : [
            p(
              "Розрахунок за замовлення здійснюється безпосередньо в Закладі у спосіб, який він пропонує. Онлайн-оплата через цей сервіс не проводиться."
            ),
          ],
    },
    {
      key: "delivery",
      title: "Отримання замовлення",
      blocks: [
        // Вимога LiqPay п.3 називає доставку прямо, тож розділ має бути навіть
        // тоді, коли доставки немає — інакше перевірка зарахує його відсутнім.
        // Не стверджуємо, що заклад не доставляє взагалі — деякі доставляють
        // іншими каналами. Стверджуємо лише те, що вірне для всіх: цей сервіс
        // обслуговує замовлення за столом.
        p(
          "Замовлення обслуговується безпосередньо в Закладі, за столом Гостя. Доставка через цей сервіс не здійснюється."
        ),
        p(
          "Строк подачі страв визначається Закладом і залежить від складності приготування та поточного завантаження кухні."
        ),
      ],
    },
    {
      key: "refund",
      title: "Повернення коштів",
      blocks: [
        p(
          "Страви та напої належної якості є продовольчими товарами і не підлягають обміну та поверненню відповідно до Переліку, затвердженого Постановою Кабінету Міністрів України № 172 від 19.03.1994."
        ),
        p("Кошти повертаються у таких випадках:"),
        ul([
          "замовлення оплачено, але не було виконане Закладом;",
          "подано не ту страву, що була замовлена;",
          "страва або напій неналежної якості;",
          "помилкове або подвійне списання коштів.",
        ]),
        p(
          "У разі надання послуги неналежної якості Гість має права, передбачені статтею 10 Закону України «Про захист прав споживачів», зокрема право вимагати усунення недоліків, зменшення ціни або повернення коштів."
        ),
        p(
          "Щоб оформити повернення, зверніться до адміністратора Закладу на місці або за контактами, вказаними нижче. Звернення розглядається Закладом невідкладно."
        ),
        hasOnlinePayment
          ? p(
              `Кошти, сплачені онлайн, повертаються ${viaService} на ту саму картку, з якої була здійснена оплата. Строк зарахування визначається банком, що випустив картку, і не залежить від Закладу.`
            )
          : p(
              "Кошти повертаються у спосіб, у який була здійснена оплата, відповідно до порядку, встановленого Закладом."
            ),
      ],
    },
    {
      key: "duties",
      title: "Права та обов'язки сторін",
      blocks: [
        p("Заклад зобов'язується:"),
        ul([
          "надати страви та напої в кількості та якості, що відповідають замовленню;",
          "надати достовірну інформацію про склад, вагу та ціну позицій меню;",
          "обробляти персональні дані Гостя виключно з метою виконання замовлення.",
        ]),
        p("Гість зобов'язується:"),
        ul([
          "оплатити замовлення на узгоджених умовах;",
          "ознайомитись з умовами цієї Угоди до оплати;",
          "повідомити персонал про наявність алергії або обмежень у харчуванні до замовлення.",
        ]),
      ],
    },
    {
      key: "liability",
      title: "Відповідальність сторін",
      blocks: [
        p("Заклад не несе відповідальності за:"),
        ul([
          "наслідки вживання страв, про непереносимість складників яких Гість не повідомив персонал до замовлення;",
          "незначні розбіжності між зображенням страви в меню та її фактичним виглядом;",
          "затримки платежу, спричинені роботою платіжного сервісу або банку Гостя.",
        ]),
        // Пом'якшено порівняно зі skymarket: беззастережне зняття
        // відповідальності перед споживачем може бути визнане несправедливою
        // умовою договору за ст. 18 ЗУ «Про захист прав споживачів».
        p(
          "Наведені обмеження не звільняють Заклад від відповідальності, передбаченої законодавством про захист прав споживачів."
        ),
        p(
          "Сторони звільняються від відповідальності за невиконання зобов'язань, спричинене обставинами непереборної сили: воєнними діями, стихійним лихом, рішеннями органів державної влади, аваріями в мережах електропостачання чи зв'язку та іншими подіями поза розумним контролем сторін."
        ),
      ],
    },
    {
      key: "personalData",
      title: "Персональні дані",
      blocks: [
        p(
          "Заклад обробляє персональні дані Гостя відповідно до Закону України «Про захист персональних даних» і виключно з метою виконання замовлення та розрахунку. Дані не передаються третім особам, крім осіб, залучених до виконання замовлення та проведення розрахунку, і випадків, передбачених законом."
        ),
        hasOnlinePayment
          ? p(
              "Дані банківської картки обробляє платіжний сервіс на своїй захищеній сторінці. Заклад їх не отримує, не обробляє і не зберігає."
            )
          : null,
      ].filter(Boolean),
    },
    {
      key: "restrictions",
      title: "Заборонена поведінка та права на матеріали",
      blocks: [
        p("Користуючись цією сторінкою, заборонено:"),
        ul([
          "обходити або вимикати технічні засоби захисту сторінки, втручатися в її роботу;",
          "намагатися отримати доступ до чужого замовлення чи рахунку або оплатити його;",
          "надавати неправдиві дані або іншим способом вводити Заклад в оману;",
          "надсилати через форми на сторінці повідомлення небажаного, образливого чи протиправного змісту;",
          "використовувати сторінку для дій, заборонених законодавством України.",
        ]),
        // Не стверджуємо, кому саме належать матеріали: фото страв — закладу,
        // інтерфейс — Skyservice, і для різних закладів набір різний.
        p(
          "Матеріали сторінки — тексти, зображення, оформлення — захищені авторським правом і належать їх правовласникам. Використання без дозволу правовласника заборонене."
        ),
      ],
    },
    {
      key: "final",
      title: "Строк дії та інші умови",
      blocks: [
        ul([
          "Угода діє з моменту акцепту і до повного виконання сторонами своїх зобов'язань.",
          // Виправлено проти skymarket: там нова редакція діяла з моменту
          // публікації без застережень, що для споживчого договору ризиковано.
          "Заклад має право змінювати умови цієї Угоди. До вже оформлених та оплачених замовлень застосовується редакція, чинна на момент оплати.",
          "Спори вирішуються шляхом переговорів, а в разі недосягнення згоди — у судовому порядку за законодавством України.",
          "Якщо окреме положення Угоди визнано недійсним, решта положень зберігають чинність.",
        ]),
      ],
    },
  ];

  // Текст із бекенду додається в кінець відповідного розділу.
  return sections.map((section) => {
    const extra =
      terms &&
      typeof terms[section.key] === "string" &&
      terms[section.key].trim();
    return extra
      ? { ...section, blocks: [...section.blocks, p(extra)] }
      : section;
  });
};
